import { Component, JSX, ValidComponent, createMemo, splitProps } from "solid-js";
import { Dynamic } from "solid-js/web";
import { requireDraggableContext } from "../DraggableContext";
import styles from '../st-draggable.module.css';

export type ComponentProps<T> = T extends Component<infer P> ?
    P : T extends keyof JSX.IntrinsicElements
    ? JSX.IntrinsicElements[T] : Record<string, unknown>

export type HandleProps<T extends ValidComponent = 'div'> = {
    as?: T;
    class?: string;
} & ComponentProps<T>;

export default function Handle<T extends ValidComponent = 'div'>(props: HandleProps<T>) {
    const [local, other] = splitProps(props, ['as', 'class']);
    const ctx = requireDraggableContext();

    const className = createMemo(() => `${styles.handle} ${props.class ?? ''}`);

    ctx.setHasHandle(true);
    return <Dynamic
        component={local.as ?? 'div'}
        {...other}
        class={className()}
    >
        {props.children}
    </Dynamic>
}
